import script from "./CGVPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CGVPage.vue?vue&type=script&setup=true&lang=js"

import "./CGVPage.vue?vue&type=style&index=0&id=231d7ec8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-231d7ec8"]])

export default __exports__